<template>
    <Section id="testimonials" as="section" eyebrow="Testimonials" title="What people are saying">
        <div class="-mx-3 mt-8 items-start sm:mt-16 md:flex lg:mt-20">
            <div v-for="(group, index) in groupedTestimonials" :key="index" class="px-3 md:w-1/3">
                <Card v-for="testimonial in group" :key="testimonial.id" class="mb-6 w-full font-light text-gray-800">
                    <div class="mb-4 flex w-full items-center">
                        <div class="size-10 overflow-hidden rounded-full border border-gray-200 bg-gray-50">
                            <img src="/images/default-avatar.png" alt="">
                        </div>
                        <div class="grow pl-3">
                            <h6 class="font-semibold text-gray-900">{{ testimonial.name }}</h6>
                        </div>
                    </div>
                    <div class="w-full">
                        <p class="leading-relaxed text-gray-600"><span
                                class="mr-1 text-lg leading-none font-bold text-primary-300 italic">"</span>{{
                                    testimonial.testimonial }}
                            <span class="ml-1 text-lg leading-none font-bold text-primary-300 italic">"</span>
                        </p>
                    </div>
                </Card>
            </div>
        </div>
    </Section>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import Section from '@/components/ui/Section.vue';
import Card from '@/components/ui/Card.vue';

const testimonials = ref([]);
const groupedTestimonials = ref([]);

onMounted(async () => {
    const response = await axios.get('/api/testimonials');
    testimonials.value = response.data.data;

    for (let i = 0; i < testimonials.value.length; i += 2) {
        groupedTestimonials.value.push(testimonials.value.slice(i, i + 2));
    }
});
</script>
